/* js/accordion.js */

;(function($, window, document) {
   
    $(document).ready(function($) {
        
        if(typeof $.fn.accordion == 'function') {
            
            $(document).accordion({
              // Put custom options here
              heightStyle: 'content',
              header: '.toggler',
              collapsible: true,
              active: false,
              create: function(event, ui) {
                ui.header.addClass('active');
                $('.toggler').attr('tabindex', 0);
              },
              activate: function(event, ui) {
                ui.newHeader.addClass('active');
                ui.oldHeader.removeClass('active');
                $('.toggler').attr('tabindex', 0);
                
                $(window).trigger('resize');
              }
            });
        
        }
        
    });

})(jQuery, window, document);